import React from "react";
import List from "@material-ui/core/List";
import ListSubheader from "@material-ui/core/ListSubheader";
import { Ownership } from "../../../../../../../services/ownership/types/ownership";
import { ListItem, ListItemText } from "@material-ui/core";

interface OwnershipInfoProps {
  title: string;
  owners: Ownership[];
}

export const OwnershipInfo = ({ title, owners }: OwnershipInfoProps) => {

  return (
    <List
      subheader={
        <ListSubheader component="div" id="nested-list-subheader">
          {title}
        </ListSubheader>
      }
    >
      {owners.map((owner) => {
        return (
          <ListItem>
            <ListItemText primary={`${owner.name} - ${owner.split}%`} />
          </ListItem>
        );
      })}
    </List>
  );
};
